export const PUBLIC_RECAPTCHA_SITE_KEY = '6Lcn-PoqAAAAAJ2aXT8oW8wLN0ID9KpRVQhOPouA';
